import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const EmailClick = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox="0 0 24 24"
    data-test="icon-email-click"
    {...props}
  >
    <path
      d="M10.902 11.6762L12.912 18.3744C12.9429 18.4777 13.0001 18.5711 13.0779 18.6456C13.1557 18.7201 13.2515 18.7731 13.356 18.7995C13.4604 18.8259 13.57 18.8247 13.6738 18.7961C13.7777 18.7675 13.8723 18.7124 13.9485 18.6362L14.9723 17.6124L17.6138 20.2539C17.6716 20.3118 17.7402 20.3576 17.8158 20.3889C17.8913 20.4202 17.9723 20.4363 18.054 20.4363C18.1358 20.4363 18.2168 20.4202 18.2923 20.3889C18.3678 20.3576 18.4365 20.3118 18.4943 20.2539L20.2553 18.4929C20.3131 18.4351 20.359 18.3665 20.3903 18.291C20.4216 18.2154 20.4377 18.1345 20.4377 18.0527C20.4377 17.9709 20.4216 17.89 20.3903 17.8144C20.359 17.7389 20.3131 17.6702 20.2553 17.6124L17.6138 14.9709L18.6375 13.9502C18.7137 13.8741 18.7688 13.7794 18.7975 13.6756C18.8262 13.5718 18.8274 13.4623 18.8011 13.3579C18.7748 13.2534 18.7219 13.1576 18.6475 13.0797C18.573 13.0019 18.4797 12.9447 18.3765 12.9137L11.6775 10.9037C11.5701 10.8718 11.4561 10.8695 11.3475 10.8969C11.2389 10.9244 11.1397 10.9806 11.0604 11.0596C10.981 11.1387 10.9244 11.2377 10.8965 11.3462C10.8687 11.4547 10.8706 11.5687 10.902 11.6762V11.6762Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2923 10.8752C19.1847 9.36933 18.6466 7.92611 17.7421 6.71744C16.8375 5.50876 15.6045 4.58558 14.1901 4.05785C12.7756 3.53011 11.2393 3.42008 9.76405 3.74084C8.28883 4.06161 6.9369 4.79966 5.86929 5.86707C4.80168 6.93449 4.06339 8.28629 3.74236 9.76146C3.42133 11.2366 3.5311 12.773 4.05858 14.1875C4.58606 15.6021 5.50902 16.8352 6.71753 17.74C7.92605 18.6448 9.36917 19.1832 10.875 19.2909"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6096 9.75023C15.3311 9.06121 14.8862 8.45192 14.3147 7.97677C13.7432 7.50163 13.0629 7.17542 12.3346 7.0273C11.6063 6.87917 10.8527 6.91373 10.141 7.1279C9.42932 7.34206 8.78177 7.72916 8.25617 8.25462C7.73058 8.78008 7.34331 9.42754 7.12896 10.1392C6.91461 10.8508 6.87986 11.6044 7.0278 12.3328C7.17574 13.0611 7.50177 13.7415 7.97677 14.3131C8.45177 14.8847 9.06095 15.3297 9.7499 15.6085"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
